<template>
	<span class="cabecalho">
		<v-list-item-subtitle id="subtitulo" class="item-text" :class="['text', corSubtitulo]">
			<texto-tooltip
				:tamanho-maximo="25"
				:texto="getNumeroCabecalho | numeroAtaFilter(podeExibirAcaoEditar)"
			></texto-tooltip>
			<v-icon
				v-if="podeExibirAcaoEditar"
				v-az-auth="permissoes.ataNumeroAtaEditar"
				class="material-icons ml-1"
				:class="['text', corSubtitulo]"
				size="15"
				@click="abrirModal"
				>mdi-pencil</v-icon
			>
		</v-list-item-subtitle>

		<modal
			:exibir="exibir"
			:titulo="titulo"
			:max-width="400"
			@close="$emit('abrir-ou-fechar-modal')"
			:custom-actions="false"
			:is-confirmar-visivel="true"
			:is-confirmar-desabilitado="!formIsValid"
			:acao-cancelar="fecharModal"
			:acao-confirmar="salvar"
			nome-botao-confirmar="Salvar"
			:zerar-padding-inferior="true"
		>
			<template #body>
				<v-form class="modal-editar-numero-ata__form" ref="form" v-model="formIsValid" lazy-validation>
					<v-row class="mb-1">
						<v-col cols="12">
							<label-personalizado
								:nome-campo="nomeCampo"
								:obrigatorio-por-padrao="true"
							></label-personalizado>
							<v-text-field
								v-model="numero"
								:rules="rules"
								dense
								clearable
								type="string"
								counter="30"
								class="ma-0 py-0"
								:placeholder="placeholderCampo"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</template>
		</modal>
	</span>
</template>
<script>
import { mutationTypes } from '@/core/constants'

export default {
	name: 'campo-editar-numero',
	props: {
		exibir: Boolean,
		titulo: {
			type: String,
			default: '',
		},
		situacao: {
			type: String,
			default: null,
		},
		situacoesValidas: {
			type: Array,
			default: () => [],
		},
		numeroIsManual: {
			type: Boolean,
		},
		rules: {
			type: Array,
			default: () => [],
		},
		corSubtitulo: {
			type: String,
			default: 'white--text',
		},
		nomeCampo: {
			type: String,
			default: 'Número da Ata',
		},
		placeholderCampo: {
			type: String,
			default: 'Informe o número da ata aqui',
		},
		isAtaCancelada: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			formIsValid: false,
		}
	},
	computed: {
		numero: {
			get() {
				return this.$store.state.campoEditarNumero.numero
			},
			set(numero) {
				this.$store.commit(mutationTypes.COMUM.CAMPO_EDITAR_NUMERO.SET_NUMERO, numero)
			},
		},
		getNumeroCabecalho() {
			let info = this.$store.state.cabecalhoPadrao
			let item = this.buscarPorSlotName(info, 'numero')

			return item.subtitulo.texto
		},
		podeExibirAcaoEditar() {
			return this.numeroIsManual && this.situacoesSaoValidas() && !this.isAtaCancelada
		},
		validacao() {
			return this.formIsValid && this.numero !== this.getNumeroCabecalho && this.situacoesSaoValidas()
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.COMUM.CAMPO_EDITAR_NUMERO.SET_NUMERO, null)
	},
	methods: {
		async salvar() {
			if (this.validacao) {
				this.$emit('salvar-numero')
				this.mostrarNotificacaoSucessoDefault()
				this.fecharModal()
			}
		},
		buscarPorSlotName(lista, slotName) {
			return lista.find((item) => item.slotName === slotName)
		},
		abrirModal() {
			this.$emit('abrir-ou-fechar-modal')
			this.numero = this.getNumeroCabecalho
		},
		fecharModal() {
			this.$emit('abrir-ou-fechar-modal')
		},
		situacoesSaoValidas() {
			return (
				!this.situacao ||
				(this.situacoesValidas.length > 0 &&
					this.situacoesValidas.filter((element) => element === this.situacao).length > 0)
			)
		},
	},
}
</script>
<style lang="stylus" scoped>
.cabecalho
	.label
		font-weight bold !important
		font-size 0.75em !important
		color white !important

	.item-text
		display inline-flex !important
		font-size .8em !important
		color white !important

.modal-editar-numero-ata__form
	margin-top: 0.9375rem
	margin-bottom -1rem

@media (min-width: 1366px)
	.arp-flex-lg-nowrap
		flex-wrap: nowrap !important;
</style>
